/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {InvoiceRowSkeletonMobile} from "./InvoiceRowSkeletonMobile";
import {InvoiceRowHeaderSkeleton} from "./InvoiceRowHeaderSkeleton";
import {InvoiceRowSkeleton} from "./InvoiceRowSkeleton";

export const InvoiceSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <InvoiceRowSkeletonMobile key={i}/>)}</>
        :
        <><InvoiceRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <InvoiceRowSkeleton key={i}/>)}</>
}

